import React from 'react';
import { HtmlRenderer, MemberPostHtmlRenderer } from '@/components/HtmlRenderer';
import { MarkdownRenderer } from '@/components/MarkdownRenderer';

type Props = {
  body: string;
  className?: string;
  /**
   * 省略可にしない。これは「どちらのサニタイザを使うか」の選択そのもので、
   * 既定値を持たせると、渡し忘れた呼び出し側が黙って緩い方（運営記事用）で
   * 会員の HTML を描いてしまう。必須にしておけば渡し忘れは tsc で止まる。
   */
  isMemberPost: boolean;
};

/**
 * PostBodyRenderer
 * 目的: 既存記事（Markdown/プレーン）と、TipTap導入後の記事（HTML）を両対応で描画する
 *
 * 引数:
 * - body: 本文（HTML or Markdown/プレーン）
 * - isMemberPost: 会員が書いた記事かどうか（true の場合は sanitizeMemberPostHtml による
 *   会員投稿用のサニタイズ・画像許可リストを使う）
 *
 * 戻り値:
 * - ReactNode
 */
export function PostBodyRenderer({ body, className, isMemberPost }: Props) {
  const value = body ?? '';

  // HTMLっぽい（TipTapの出力）かをざっくり判定
  // div を含めるのは、本文が動画1本だけの記事（<div data-youtube-id>）を
  // Markdown 扱いにしないため
  const looksLikeHtml =
    /<\/?(p|h1|h2|h3|ul|ol|li|blockquote|img|a|pre|code|br|hr|div)\b/i.test(value);

  if (looksLikeHtml) {
    // 会員が書いた記事は、画像の配信元を結会のものに限る方針で描く
    return isMemberPost ? (
      <MemberPostHtmlRenderer html={value} className={className} />
    ) : (
      <HtmlRenderer html={value} className={className} />
    );
  }
  return <MarkdownRenderer content={value} className={className} />;
}
